import { makeStyles } from '@map/theme';
import { Typography } from '@mui/material';
import { ReactNode } from 'react';

const useStyles = makeStyles(({ spacing, palette }) => ({
  title: {
    marginTop: spacing(1),
  },
  subtitle: {
    padding: spacing(1, 2, 4, 2),
    color: palette.neutrals[800],
  },
}));

type Props = {
  title?: ReactNode;
  subtitle: ReactNode;
};

const PublicPageHeader: FC<Props> = ({ title, subtitle }) => {
  const { classes } = useStyles();
  return (
    <div>
      <Typography className={classes.title} variant="h6" align="center">
        {title}
      </Typography>
      <Typography className={classes.subtitle} variant="body2" align="center">
        {subtitle}
      </Typography>
    </div>
  );
};

export default PublicPageHeader;
